import { FC, memo } from 'react'
import { NodeProps, Position } from '@xyflow/react'
import { useTranslate } from 'react-admin'
import Typography from '@mui/material/Typography'
import EditNoteIcon from '@mui/icons-material/EditNote'
import BaseNode from './BaseNode'
import { DataStoreUpdateNodeData } from '../types'
import { xxllncColor } from '../../../layout/theme/color'

const DataStoreUpdateNode: FC<NodeProps> = ({ id, data, selected }) => {
  const translate = useTranslate()
  const nodeData = data as DataStoreUpdateNodeData
  const recordId = (nodeData.recordId ?? '').trim()
  const hasContent = Boolean((nodeData.content ?? '').trim())
  const subtitle = recordId
    ? `${translate('workflow.node.dataStoreUpdateSummary')} · ${recordId.slice(0, 8)}…`
    : translate('workflow.node.dataStoreMissingRecordId')

  const showError = !recordId || !hasContent
  const errorText = !recordId
    ? translate('workflow.node.dataStoreMissingRecordId')
    : translate('workflow.node.dataStoreMissingContent')

  return (
    <BaseNode
      // eslint-disable-next-line camelcase
      nodeType="data_store_update"
      icon={<EditNoteIcon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={subtitle}
      selected={selected}
      handles={[
        { type: 'target', position: Position.Top },
        { type: 'source', position: Position.Bottom },
      ]}
    >
      {showError && (
        <Typography
          variant="caption"
          sx={{
            color: xxllncColor.orange100,
            fontWeight: 600,
            display: 'block',
            lineHeight: 1.35,
          }}
        >
          {errorText}
        </Typography>
      )}
    </BaseNode>
  )
}

export default memo(DataStoreUpdateNode)
